class FinancialUtils {
  public roundTo(value: number, digits = 2): number {
    return Math.round(value * 10 ** digits) / 10 ** digits;
  }

  public formatPrice(
    price: number,
    locale = 'en-US',
    currency = 'USD',
  ): string {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
    }).format(price);
  }
}

const financialUtils = new FinancialUtils();

export { financialUtils };
